export default __webpack_public_path__ + "static/media/crude-graph-on1.5b24ed2a.svg";